import { useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { SITE } from "../../config/site";

const links = [
  { label: "What it does", href: "/#features", testId: "nav-link-features" },
  { label: "Why NXTPlate", href: "/#why", testId: "nav-link-why" },
  { label: "Plans", href: "/#plans", testId: "nav-link-plans" },
  { label: "Support", href: "/support", testId: "nav-link-support" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header
      data-testid="site-header"
      className="fixed inset-x-0 top-0 z-50 border-b border-white/40 bg-white/70 backdrop-blur-xl"
    >
      <div className="mx-auto flex h-16 md:h-20 max-w-7xl items-center justify-between px-6 md:px-10">
        <Link
          to="/"
          data-testid="header-logo"
          className="font-display text-2xl font-bold tracking-tight text-neutral-900"
        >
          NXT<span className="text-coral">Plate</span>
        </Link>

        <nav className="hidden items-center gap-8 md:flex" aria-label="Primary">
          {links.map((l) => (
            <Link
              key={l.href}
              to={l.href}
              data-testid={l.testId}
              className="text-sm font-medium text-neutral-600 transition-colors duration-200 hover:text-neutral-900"
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:block">
          <a
            href={SITE.appStoreUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-get-app-link"
            className="inline-flex items-center gap-2 rounded-full bg-coral px-5 py-2.5 text-sm font-semibold text-white shadow-[0_4px_16px_rgba(255,107,87,0.35)] transition-all duration-200 hover:bg-coral-dark hover:shadow-[0_8px_24px_rgba(255,107,87,0.45)]"
          >
            Get the App
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-neutral-900"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            data-testid="mobile-menu"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
            className="overflow-hidden border-t border-neutral-200/60 bg-white/90 backdrop-blur-xl md:hidden"
            aria-label="Mobile"
          >
            <div className="flex flex-col gap-1 px-6 py-4">
              {links.map((l) => (
                <Link
                  key={l.href}
                  to={l.href}
                  data-testid={`mobile-${l.testId}`}
                  onClick={() => setOpen(false)}
                  className="rounded-lg px-3 py-3 text-base font-medium text-neutral-700 transition-colors duration-200 hover:bg-bone hover:text-neutral-900"
                >
                  {l.label}
                </Link>
              ))}
              <a
                href={SITE.appStoreUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="mobile-get-app-link"
                onClick={() => setOpen(false)}
                className="mt-2 rounded-full bg-coral px-4 py-3 text-center text-base font-semibold text-white transition-colors duration-200 hover:bg-coral-dark"
              >
                Get the App
              </a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
